import React from 'react';
import styles from './InputLoaderIcon.scss';

const InputLoaderIcon = () => {
  return (
    <svg
      className={styles.inputLoaderIcon}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_704_17483)">
        <path
          d="M4.5 12.0016C4.5 11.4493 4.05228 11.0016 3.5 11.0016C2.94772 11.0016 2.5 11.4493 2.5 12.0016H4.5ZM12.5 2C11.9477 2 11.5 2.44772 11.5 3C11.5 3.55228 11.9477 4 12.5 4V2ZM20.5 12.0016C20.5 16.421 16.9181 20.0032 12.5 20.0032V22.0032C18.023 22.0032 22.5 17.5252 22.5 12.0016H20.5ZM12.5 20.0032C8.08189 20.0032 4.5 16.421 4.5 12.0016H2.5C2.5 17.5252 6.97698 22.0032 12.5 22.0032V20.0032ZM12.5 4C16.9181 4 20.5 7.58228 20.5 12.0016H22.5C22.5 6.47804 18.023 2 12.5 2V4Z"
          fill="#E8E8E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_704_17483">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InputLoaderIcon;
